<template>
  <backbar-page-layout
    v-if="canPerform('authcore.oAuthFactors.list')"
    back-title="user_details_social_login.back_title"
    title="user_details_social_login.title"
    :user-id="id"
    :loading="loading"
  >
    <template #alert>
      <b-row>
        <b-col>
          <b-alert
            :show="actionDone"
            variant="success"
          >
            {{ $t('user_details_social_login.text.disconnect_success') }}
          </b-alert>
        </b-col>
      </b-row>
    </template>
    <b-bsq-modal
      ref="modal"
      v-model="isModalEnabled"
      :header-title="modalHeaderTitle"
      :button-title="modalButtonTitle"
      :button-variant="modalButtonVariant"
      @ok="modalSubmit"
    >
      <div class="mt-3 mb-5">
        <div v-if="isDisconnectModalEnabled">
          <div v-if="step === STEP.DISCONNECT">
            <b-row class="mb-4 text-center">
              <b-col>
                <img src="@/assets/delete-social-login-warning.svg" alt="" />
              </b-col>
            </b-row>
            <i18n path="user_details_social_login.text.disconnect" tag="div" class="mb-3">
              <span place="service">{{ selectedOAuthFactor.service }}</span>
            </i18n>
          </div>
          <i18n v-else-if="step === STEP.FAILED" path="user_details_social_login.text.disconnect_failed"></i18n>
        </div>
      </div>
    </b-bsq-modal>
    <b-container>
      <b-table
        show-empty
        :empty-text="$t('user_details_social_login.text.no_social_login')"
        class="theme-general"
        thead-class="text-grey"
        :items="oAuthFactors"
        :fields="fields"
      >
        <template v-slot:cell(actions)="data">
          <b-button
            variant="danger"
            @click="disconnectModal(data.item.id)"
          >
            {{ $t('user_details_social_login.button.disconnect') }}
          </b-button>
        </template>
      </b-table>
    </b-container>
  </backbar-page-layout>
</template>

<script>
import { mapState } from 'vuex'
import BackbarPageLayout from '@/components/BackbarPageLayout.vue'

import store from '@/store'

import i18n from '@/i18n'
const STEP = {
  INITIAL: 0,
  DISCONNECT: 1,
  FAILED: -1
}

export default {
  name: 'UserDetailsSocialLogin',
  components: {
    BackbarPageLayout
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      isDisconnectModalEnabled: false,

      selectedOAuthFactor: undefined,
      fields: [
        { key: 'service', label: i18n.t('user_details_social_login.table.header.social_platform'), tdClass: 'align-middle' },
        { key: 'oauthUserId', label: i18n.t('user_details_social_login.table.header.id'), tdClass: 'align-middle' },
        { key: 'createdAt', label: i18n.t('user_details_social_login.table.header.associated_at'), tdClass: 'align-middle' },
        { key: 'lastUsedAt', label: i18n.t('user_details_social_login.table.header.last_used'), tdClass: 'align-middle' },
        { key: 'actions', label: i18n.t('user_details_social_login.table.header.actions'), thClass: 'text-center', tdClass: 'text-center' }
      ],

      STEP
    }
  },

  computed: {
    ...mapState('management/userDetails/oauthFactorsList', [
      'loading',
      'actionDone',
      'actionError',

      'oAuthFactors'
    ]),
    step () {
      if (this.isDisconnectModalEnabled) {
        if (this.actionError) {
          return STEP.FAILED
        }
        return STEP.DISCONNECT
      }
      return STEP.INITIAL
    },
    isModalEnabled: {
      get () {
        return this.isDisconnectModalEnabled
      },
      set () {
        setTimeout(() => {
          this.isDisconnectModalEnabled = false
          store.commit('management/userDetails/oauthFactorsList/CLEAR_ACTION_STATES')
        }, 500)
      }
    },
    modalHeaderTitle () {
      if (this.isDisconnectModalEnabled) {
        return i18n.t('user_details_social_login.text.disconnect_social_login')
      }
      return ''
    },
    modalButtonTitle () {
      if (this.isDisconnectModalEnabled) {
        if (this.step === STEP.DISCONNECT) {
          return i18n.t('user_details_social_login.button.disconnect')
        } else if (this.step === STEP.FAILED) {
          return i18n.t('button.ok')
        }
      }
      return ''
    },
    modalButtonVariant () {
      if (this.isDisconnectModalEnabled) {
        if (this.step === STEP.DISCONNECT) {
          return 'danger'
        } else if (this.step === STEP.FAILED) {
          return 'primary'
        }
      }
      return ''
    }
  },

  watch: {
    async actionDone (newVal) {
      console.log(newVal)
      if (newVal) {
        await store.dispatch('management/userDetails/oauthFactorsList/list', this.id)
        this.$refs.modal.hide()
        this.isModalEnabled = false
      }
    }
  },

  created () {},
  async mounted () {
    if (this.oAuthFactors === undefined) {
      await store.dispatch('management/userDetails/oauthFactorsList/list', this.id)
    }
  },
  updated () {},
  destroyed () {},

  methods: {
    disconnectModal (id) {
      this.selectedOAuthFactor = this.oAuthFactors.find(item => item.id === id)
      this.isDisconnectModalEnabled = true
    },
    async modalSubmit () {
      if (this.isDisconnectModalEnabled) {
        if (this.step === STEP.DISCONNECT) {
          await this.disconnect(this.selectedOAuthFactor.id)
        } else if (this.step === STEP.FAILED) {
          this.$refs.modal.hide()
          this.isModalEnabled = false
        }
      }
    },
    async disconnect (id) {
      await store.dispatch('management/userDetails/oauthFactorsList/delete', id)
    }
  }
}
</script>
